export default "__VITE_ASSET__a1R2oY$f__"